import { reviewService } from '../_config';

export const reviewUrls = {
    getReviewsByreferenceType: reviewService + '/reviews',
    getMyReviews: reviewService + '/reviews/me',
    getReviewSummary: reviewService + '/reviews/summary'
};
